export const DESCRIPTION_INPUT_HEIGHT_IN_LINES = 3;
export const SKU_NAME_MAX_INPUT_LENGTH = 100;
export const SKU_DESCRIPTION_MAX_INPUT_LENGTH = 500;
export const SKU_NAME_CHAR_COUNTER_THRESHOLD = 10;
export const SKU_DESCRIPTION_CHAR_COUNTER_THRESHOLD = 50;

export const SKU_FLYOUT_DROPDOWN_VIEWPORT_MARGIN = 24;
export const SKU_FLYOUT_DROPDOWN_MIN_MENU_HEIGHT = 120;

// Height of the flyout's sticky submit footer plus an 8px gap.
export const SKU_FLYOUT_FOOTER_OFFSET = 80;

export const SKU_FOOTER_BAR_HEIGHT = 72;

export const ITEM_SAVE_STATUS = Object.freeze({
  SAVED: 'saved',
  PARTIALLY_SAVED: 'partiallySaved',
  NOTHING_SAVED: 'nothingSaved',
});

export const ITEM_AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE_TODAY: 'unavailable_today',
  UNAVAILABLE_INDEFINITELY: 'unavailable_indefinitely',
};

export const ITEM_AVAILABILITY_STATUS_OPTIONS = Object.values(ITEM_AVAILABILITY_STATUS);

export const PARTNER_STATE = {
  UNAVAILABLE: 'PARTNER_ENTITY_STATE_UNAVAILABLE',
  DELETED: 'PARTNER_ENTITY_STATE_DELETED',
};

export const STATUS_TO_BOOLEANS = {
  [ITEM_AVAILABILITY_STATUS.AVAILABLE]: { enabled: true, soldOut: false, partnerState: null },
  [ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY]: { enabled: true, soldOut: true, partnerState: null },
  [ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY]: {
    enabled: false,
    soldOut: false,
    partnerState: PARTNER_STATE.UNAVAILABLE,
  },
};

export const ITEM_AVAILABILITY_STATUS_MAPPING = {
  [ITEM_AVAILABILITY_STATUS.AVAILABLE]: {
    color: 'green',
    message: 'itemStatusAvailable',
  },
  [ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY]: {
    color: 'yellow',
    message: 'itemStatusUnavailableToday',
  },
  [ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY]: {
    color: null,
    message: 'itemStatusUnavailableIndefinitely',
  },
};

export const VENUE_OPEN_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
};

export const VENUE_OPEN_STATUS_MAPPING = {
  [VENUE_OPEN_STATUS.OPEN]: {
    color: 'green',
    message: 'venueStatusOpen',
  },
  [VENUE_OPEN_STATUS.CLOSED]: {
    color: 'red-dark',
    message: 'venueStatusPausedForToday',
  },
};

export const VENUE_OPEN_STATUS_OPTIONS = Object.values(VENUE_OPEN_STATUS);

export const getSkuCollapseKey = venueId => `sku-collapse-${venueId}`;
